import { useQuery, gql } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import Alert, { WARNING_TYPE } from 'components/Alerts';
import get from 'lodash/get';
import { Col, Row, Container } from 'reactstrap';
import styled from 'styled-components/macro';
import { getLocalStorageData } from 'utils/localStorage';

const GET_SITE_MESSAGES = gql`
  query getSiteMessages {
    siteMessages {
      id
      message
      type
    }
  }
`;

const StyledRow = styled(Row)`
  margin-top: 1rem;
  padding: 0;
`;

function SiteMessages() {
  const userReceivesEmails = getLocalStorageData('userReceivesEmails');
  const [showUserEmail, setShowUserEmail] = useState(userReceivesEmails);

  useEffect(() => {
    function checkUserData() {
      const item = localStorage.getItem('userReceivesEmails');
      if (item) {
        setShowUserEmail(item);
      }
    }

    window.addEventListener('storage', checkUserData);

    return () => {
      window.removeEventListener('storage', checkUserData);
    };
  });

  const { data: siteMessagesData } = useQuery(GET_SITE_MESSAGES);
  const siteMessages = get(siteMessagesData, 'siteMessages', []);

  return (
    <Container>
      <StyledRow>
        <Col sm={12}>
          {siteMessages.map(message => {
            return (
              <Alert key={`alert_${message.id}`} type={message.type} canClose={false} noIcon={true}>
                {message.message}
              </Alert>
            );
          })}
          {showUserEmail === 'false' && (
            <Alert type={WARNING_TYPE} canClose={false}>
              You are not currently receiving emails because of an invalid email address.{' '}
              <a href='/profile'>Click here to view your profile.</a>
            </Alert>
          )}
        </Col>
      </StyledRow>
    </Container>
  );
}

SiteMessages.propTypes = {};
SiteMessages.defaultProps = {};

export default SiteMessages;
